import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { shape, string, objectOf } = PropTypes;

export default shape({
  action: string.isRequired,
  authUser: string,
  createdBy: string,
  createdDate: string,
  description: string,
  displayName: string.isRequired,
  eventData: objectOf(string).isRequired,
  eventType: string,
  recurring: objectOf(string),
  recurringDescription: string,
  schedule: string.isRequired,
  scheduleID: string,
  teamName: string,
  timezone: string,
  upcomingID: string
});



// WEBPACK FOOTER //
// ./js/types/api/upcoming.js